import React from "react";
import { PortfolioProperty } from "../types/ownerPortfolio.types";
import InspectionSidebar from "./InspectionSidebar";
import PortfolioInsight from "./PortfolioInsight";
import PortfolioSidebar from "./PortfolioSidebar";

interface PortfolioPanelsProps {
  property: PortfolioProperty;
  accessToken: string | null;
  insightOpen: boolean;
  inspectionOpen: boolean;
  onCloseInspection: () => void;
  onCloseInsight: () => void;
}

interface PortfolioPanelButtonsProps {
  property: PortfolioProperty;
  insightOpen: boolean;
  inspectionOpen: boolean;
  onToggleInsight: () => void;
  onToggleInspection: () => void;
}

const toggleClass =
  "whitespace-nowrap rounded-full border border-white/10 px-2.5 py-1.5 text-[0.65rem] font-medium leading-none text-[#f0f6fc] transition-colors hover:bg-white/5";

export function PortfolioPanelButtons({
  property,
  insightOpen,
  inspectionOpen,
  onToggleInsight,
  onToggleInspection,
}: PortfolioPanelButtonsProps) {
  const canExplain = property.situation === "ALUGANDO";
  const canInspect = property.kenlo_property_id !== "";

  if (!canExplain && !canInspect) {
    return <span className="text-xs text-[#6e7681]">—</span>;
  }

  return (
    <div className="flex w-fit flex-col items-stretch gap-1.5">
      {canExplain && (
        <button
          type="button"
          className={`${toggleClass} ${insightOpen ? "border-[#6ea8ff]/40 text-[#6ea8ff]" : ""}`}
          aria-expanded={insightOpen}
          onClick={onToggleInsight}
        >
          Por que não aluga
        </button>
      )}
      {canInspect && (
        <button
          type="button"
          className={`${toggleClass} ${inspectionOpen ? "border-[#6ea8ff]/40 text-[#6ea8ff]" : ""}`}
          aria-expanded={inspectionOpen}
          onClick={onToggleInspection}
        >
          Vistoria
        </button>
      )}
    </div>
  );
}

export function PortfolioPanels({
  property,
  accessToken,
  insightOpen,
  inspectionOpen,
  onCloseInspection,
  onCloseInsight,
}: PortfolioPanelsProps) {
  const showInsight = insightOpen && property.situation === "ALUGANDO";
  const showInspection = inspectionOpen && property.kenlo_property_id !== "";

  if (!showInsight && !showInspection) {
    return null;
  }

  return (
    <>
      {showInsight && (
        <PortfolioSidebar
          property={property}
          title="Por que não aluga"
          closeLabel="Fechar funil"
          testId="insight-sidebar"
          titleId="insight-sidebar-title"
          onClose={onCloseInsight}
        >
          <PortfolioInsight property={property} />
        </PortfolioSidebar>
      )}
      {showInspection && (
        <InspectionSidebar
          property={property}
          accessToken={accessToken}
          onClose={onCloseInspection}
        />
      )}
    </>
  );
}
